<template>
    <div class="sau-common-links border flex flex-wrap items-center">
        <div class="w-full lg:pb-8">
            <h1 class="mb-4 md:mb-2 p-0">
                <template v-if="userDetails.firstname">
                    Hey {{ userDetails.firstname }}!
                </template>
                <template v-else>
                    I want to...
                </template>
            </h1>

            <div class="w-full flex flex-wrap -m-2">
                <div class="w-full sm:w-1/2 lg:w-auto p-2">
                    <a  href="/services"
                        v-if="hasPermission('products')"
                        class="btn btn-primary border-0 border-b-4 border-blue hover:border-green block lg:inline-block mb-0 py-3 px-4"
                    >
                        <span class="flex items-center justify-center text-sm" style="padding-top: 4px;">
                            <i class="fal fa-server text-2xl mr-2"></i> View my Services
                        </span>
                    </a>
                </div>
                <div
                    v-if="coloServices && typeof coloServices === 'object' && coloServices.length > 0 && hasPermission('tickets')"
                    class="w-full sm:w-1/2 lg:w-auto p-2">
                    <a href="/access"
                        class="btn btn-primary border-0 border-b-4 border-blue hover:border-green block lg:inline-block mb-0 py-3 px-4"
                    >
                        <span class="flex items-center justify-center text-sm" style="padding-top: 4px;">
                            <i class="fal fa-door-open text-2xl mr-2"></i> Open Access Request
                        </span>
                    </a>
                </div>
                <div class="w-full sm:w-1/2 lg:w-auto p-2">
                    <a  href="/billing"
                        v-if="hasPermission('invoices')"
                        class="btn btn-primary border-0 border-b-4 border-blue hover:border-green block lg:inline-block mb-0 py-3 px-4"
                    >
                        <span class="flex items-center justify-center text-sm" style="padding-top: 4px;">
                            <i class="fal fa-file-invoice text-2xl mr-2"></i> Pay an Invoice
                        </span>
                    </a>
                </div>
                <div class="w-full sm:w-1/2 lg:w-auto p-2">
                    <a  href="/support/conversations"
                        v-if="hasPermission('tickets')"
                        class="btn btn-primary border-0 border-b-4 border-blue hover:border-green block lg:inline-block mb-0 py-3 px-4"
                    >
                        <span class="flex items-center justify-center text-sm" style="padding-top: 4px;">
                            <i class="fal fa-life-ring text-2xl mr-2"></i> Get Support
                        </span>
                    </a>
                </div>
                <div class="w-full sm:w-1/2 lg:w-auto p-2">
                    <a  href="/order"
                        v-if="hasPermission('orders')"
                        class="btn btn-primary border-0 border-b-4 border-blue hover:border-green block lg:inline-block mb-0 py-3 px-4"
                    >
                        <span class="flex items-center justify-center text-sm" style="padding-top: 4px;">
                            <i class="fas fa-map-marker-alt text-2xl mr-2"></i> Order a Product
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
    props: {
        coloServices: {
            type: Array,
            default: () => [],
        }
    },
}
</script>

<style lang="scss">
.sau-common-links {
    width: 100%;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-bottom: 1rem;
    @media screen and (min-width: 768px) {
        height: 220px;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 180px;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('/img/moonscape-bg.gif');
    }

    h1 {
        font-size: 1.625rem;
        @media screen and (min-width: 1400px) {
            padding-bottom: 17px;
        }
    }
}
</style>
